var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numpad-layour"},_vm._l((_vm.keys),function(ref){
var normalKey = ref.normalKey;
var shiftKey = ref.shiftKey;
return _c('KeyButton',{key:normalKey,staticClass:"numpad",attrs:{"normalKey":normalKey,"shiftKey":shiftKey,"shiftEnabled":_vm.shiftEnabled},on:{"click":_vm.clickHandle}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5294d8c9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/numpad.vue
// module id = DQDj
// module chunks = 1